import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Row, Table, Dropdown, Nav, Button, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';

export default function ManageClass() {
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const { c_id } = useParams();
  // const [classId, setClassId] = useState(null);
  const { setLoading } = useLoading();
  const [scrollPos, setScrollPos] = useState(0);
  const [selectedClass, setSelectedClass] = useState(c_id || 1); // Default to class 1 if c_id is not provided
  const [yearId, setYearId] = useState(() => {
    return localStorage.getItem('yearId') || null;
  })
  const [selectedYear, setSelectedYear] = useState("");
  const [yearList, setYearList] = useState([]);
  const [classList, setClassList] = useState([1]);
  const [teacherList, setTeacherList] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setSelectedClass(c_id);
  }, [c_id]);

  useEffect(() => {
    setLoading(true);
    // get yearId from lastest year in database
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        const list = res.data;
        setYearList(list);

        // ถ้า yearId ยังไม่มีใน localStorage ให้ใช้ปีล่าสุด
        let initialYearId = localStorage.getItem('yearId');
        if (!initialYearId && list.length > 0) {
          initialYearId = list[0].year_id;
          localStorage.setItem('yearId', initialYearId);
        }
        setYearId(initialYearId);
        const selected = list.find(y => String(y.year_id) === String(initialYearId));
        setSelectedYear(selected ? `ปีการศึกษา ${selected.year_year}` : "");
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [setLoading]);

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getClassList`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        setClassList(res.data);
      })
      .catch(err => {
        console.error("Error loading class list:", err);
      });
  }, []);

  // get all programs from table tb_program
  const [programList, setProgramList] = useState([]);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getProgramList`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        if (res.data.length > 0) {
          // Set program list to state
          // console.log("Program List:", res.data);
          setProgramList(res.data);
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'ไม่พบข้อมูลโปรแกรม',
            text: 'กรุณาเพิ่มโปรแกรมก่อนทำการสอน',
          });
        }
      })
      .catch(err => {
        console.error("Error loading program list:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setLoading]);

  // get all teachers from table tb_teacher
  const [allTeachers, setAllTeachers] = useState([]);
  useEffect(() => {
    if (!yearId) return; // Ensure yearId is set before making the request
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getTeacherList`, { 
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        if (res.data.length > 0) {
          // Set teacher list to state
          // console.log("Teacher List:", res.data);
          setAllTeachers(res.data);
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'ไม่พบข้อมูลอาจารย์',
            text: 'กรุณาเพิ่มอาจารย์ก่อนทำการสอน',
          });
        }
      })
      .catch(err => {
        console.error("Error loading teacher list:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setLoading, yearId]);

  // get available teachers for the selected year
  const [availableTeachers, setAvailableTeachers] = useState([]);
  useEffect(() => {
    if (!yearId) return; // Ensure yearId is set before making the request
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getAvailableTeacherList/${yearId}`, { 
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        if (res.data.length > 0) {
          // Set teacher list to state
          // console.log("Teacher List:", res.data);
          setAvailableTeachers(res.data);
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'ไม่พบข้อมูลอาจารย์',
            text: 'กรุณาเพิ่มอาจารย์ก่อนทำการสอน',
          });
        }
      })
      .catch(err => {
        console.error("Error loading teacher list:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setLoading, yearId]);

  // Load teaching data when c_id and yearId change
  const [roomList, setRoomList] = useState([]);
  const [reloadRoomList, setReloadRoomList] = useState(0);

  useEffect(() => {
    if (selectedClass && yearId) {
      setLoading(true);
      axiosInstance.get(`${process.env.REACT_APP_API}/getRoomListByClassId/${selectedClass}/${yearId}`, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
        .then(res => {
          if (res.data.length > 0) {
            setRoomList(res.data);
            console.log("Room List:", res.data);
            console.log("Reload Room List:", roomList);
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'ไม่พบข้อมูลห้องเรียน',
              text: 'กรุณาเพิ่มห้องเรียนก่อนทำการสอน',
            });
          }
        })
        .catch(err => {
          Swal.fire({
            icon: 'warning',
            title: err.response?.data?.title || 'เกิดข้อผิดพลาด',
            text: err.response?.data?.message || 'ไม่สามารถโหลดห้องเรียนได้',
          })
          setRoomList([]); // Clear room list on error
        })
        .finally(() => {
          setLoading(false);
          setTimeout(() => window.scrollTo(0, scrollPos), 0);
          setTimeout(() => setScrollPos(0), 0);
        });
    }
  }, [selectedClass, yearId, setLoading, reloadRoomList]);

  // Function to handle dropdown change
  const handleSelectYear = (id) => {
  const selected = yearList.find(y => y.year_id === id);
  if (selected) {
    setYearId(id);
    setSelectedYear(`ปีการศึกษา ${selected.year_year}`);
    localStorage.setItem('yearId', id); // <-- เก็บลง LocalStorage
  }
}

  // State for modal
  const [modalMode, setModalMode] = useState("add");
  const [roomNo, setRoomNo] = useState("");
  const [programCode, setProgramCode] = useState("");
  const [roomGender, setRoomGender] = useState(""); // "" = คละ/ไม่ระบุ, "m" = ชาย, "f" = หญิง
  // ครูประจำชั้นหลายคน: teacherIds = ทุกคน (เก็บเป็น string), primaryTeacherId = ครูหลัก
  const [teacherIds, setTeacherIds] = useState([]);
  const [primaryTeacherId, setPrimaryTeacherId] = useState("");

  // เพิ่ม/เอาครูออกจากรายการที่ปรึกษา และดูแลครูหลักให้สอดคล้อง
  const toggleTeacher = (tId) => {
    const id = String(tId);
    setTeacherIds((prev) => {
      if (prev.includes(id)) {
        const next = prev.filter((x) => x !== id);
        setPrimaryTeacherId((cur) =>
          String(cur) === id ? (next[0] || "") : cur
        );
        return next;
      }
      const next = [...prev, id];
      setPrimaryTeacherId((cur) => (cur ? cur : id)); // คนแรกที่เลือก = ครูหลักโดยปริยาย
      return next;
    });
  };

  // เพิ่ม state สำหรับ roomId ที่จะแก้ไข
  const [editRoomId, setEditRoomId] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = (buttonAction, roomId) => {
    setModalMode(buttonAction);
    if (buttonAction === "add") {
      setTeacherList(availableTeachers); // ใช้ availableTeachers สำหรับการเพิ่มห้อง
      setRoomNo("");
      setProgramCode("");
      setRoomGender("");
      setTeacherIds([]);
      setPrimaryTeacherId("");
      setEditRoomId(null);
    }
    if (buttonAction === "edit") {
      const room = roomList.find(r => String(r.r_id) === String(roomId));
      if (room) {
        // console.log("Editing room:", room);
        setTeacherList(allTeachers); // ใช้ allTeachers สำหรับการแก้ไขห้อง
        setRoomNo(room.r_no);
        setProgramCode(room.p_id); // แล้วแต่ backend ส่งกลับมา
        setRoomGender(room.r_gen || "");
        const advisors = room.advisors || (room.t_id ? [{ t_id: room.t_id, is_primary: true }] : []);
        setTeacherIds(advisors.map(a => String(a.t_id)));
        const primary = advisors.find(a => a.is_primary) || advisors[0];
        setPrimaryTeacherId(primary ? String(primary.t_id) : "");
        setEditRoomId(room.r_id);
      }
    }
    setShow(true);
  }

  const handleSave = () => {
    if (modalMode === "add") {
      // Add new room
      setLoading(true);
      axiosInstance.post(`${process.env.REACT_APP_API}/addClassRoom`, {
        r_no: roomNo,
        p_code: programCode,
        r_gen: roomGender || null,
        t_ids: teacherIds,
        primary_t_id: primaryTeacherId || null,
        tb_class_c_id: c_id,
        year_id: yearId
      }, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
        .then(res => {
          Swal.fire({
            icon: 'success',
            title: 'สำเร็จ',
            text: res.data.message,
          });
          setReloadRoomList(prev => prev + 1); // <--- trigger reload
          handleClose();
        })
        .catch(err => {
          console.error("Error adding room:", err);
          Swal.fire({
            icon: 'error',
            title: err.response?.data?.title || 'เกิดข้อผิดพลาด',
            text: err.response?.data?.message || 'ไม่สามารถเพิ่มห้องเรียนได้',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
    if (modalMode === "edit") {
      // Edit existing room
      setScrollPos(window.scrollY); // เก็บตำแหน่ง scroll ปัจจุบัน
      setLoading(true);
      axiosInstance.post(`${process.env.REACT_APP_API}/editClassRoom`, {
        r_id: editRoomId,
        r_no: roomNo,
        p_code: programCode,
        r_gen: roomGender || null,
        t_ids: teacherIds,
        primary_t_id: primaryTeacherId || null,
        tb_class_c_id: c_id,
        year_id: yearId
      }, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
        .then(res => {
          handleClose();
          Swal.fire({
            icon: 'success',
            title: 'สำเร็จ',
            text: res.data.message,
          });
          setReloadRoomList(prev => prev + 1);
          // console.log("Room updated successfully:", reloadRoomList);
        })
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: err.response?.data?.title || 'เกิดข้อผิดพลาด',
            text: err.response?.data?.message || 'ไม่สามารถแก้ไขห้องเรียนได้',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ทะเบียนและหลักสูตร</Link></li>
              <li className="breadcrumb-item active" aria-current="page">จัดการห้องเรียน</li>
            </ol>
            <h4 className="main-title mb-0">จัดการห้องเรียน</h4>
          </div>
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selectedYear || "เลือกปีการศึกษา"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
              {yearList.map(item => (
                <Dropdown.Item key={item.year_id} onClick={() => handleSelectYear(item.year_id)}>
                  ปีการศึกษา {item.year_year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <Row className="g-12 mb-4">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <Nav variant="tabs" defaultActiveKey={`/registration/manage-classes/${selectedClass}`}>
              {classList.map((cls, index) => (
                <Nav.Item key={cls.c_id + '-' + index}>
                  <Nav.Link
                    as={Link}
                    to={`/registration/manage-classes/${cls.c_id}`}
                    active={String(selectedClass) === String(cls.c_id)}
                  >
                    {cls.c_class}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
         { c_id && (
          <Card className="card-one">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Card.Title as="h6" className="mb-0">{selectedYear}</Card.Title>
            </Card.Header>
            <Card.Body className="p-3">
              <Table responsive bordered hover className="mb-0">
                <thead>
                  <tr className="text-center">
                    <th scope="row" colSpan={5}>ชั้นมัธยมศึกษาปีที่ {c_id}</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th scope="col" className="text-center" style={{ width: "100px" }}>ห้อง</th>
                    <th scope="col" className="text-center" style={{ width: "100px" }}>โปรแกรม</th>
                    <th scope="col" className="text-center" style={{ width: "100px" }}>เพศ</th>
                    <th scope="col" className="text-center">อาจารย์ที่ปรึกษา</th>
                    <th scope="col" className="text-center" style={{ width: "150px" }}>
                      <Button variant="success" size="sm" onClick={() => handleShow("add")}>
                        <i className="ri-add-line"></i> เพิ่มห้องเรียน
                      </Button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {roomList && roomList.length > 0 ? (
                    roomList
                      .map((data, index) => (
                        <tr key={data.r_id}>
                          <th scope="row" className="text-center">{data.tb_class_c_id + "/" + data.r_no}</th>
                          <td className="text-center">{data.p_code}</td>
                          <td className="text-center">
                            {data.r_gen === "m" ? "ชาย" : data.r_gen === "f" ? "หญิง" : <i className="text-muted">-คละ-</i>}
                          </td>
                          <td className="text-center">
                            {data.advisors && data.advisors.length > 0 ? (
                              <div className="d-flex flex-column align-items-center gap-1">
                                {data.advisors.map((a) => (
                                  <span key={a.t_id}>
                                    {a.t_name}
                                    {a.is_primary && (
                                      <span className="badge bg-primary ms-1">ครูหลัก</span>
                                    )}
                                  </span>
                                ))}
                              </div>
                            ) : data.t_name ? (
                              data.t_name
                            ) : (
                              <i className="text-danger">-ยังไม่ระบุ-</i>
                            )}
                          </td>
                          <td className="text-center">
                            <Button variant="primary" size="sm" onClick={() => handleShow("edit", data.r_id)}>
                              <i className="ri-edit-line"></i> แก้ไข
                            </Button>
                          </td>  
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
          )}
        </Row>
        <Footer />
      </div>

      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalMode === "add" ? (
              <>
                <i className="ri-add-line"></i> เพิ่มห้องเรียน
              </>
            ) : (
              <>
                <i className="ri-edit-line"></i> แก้ไขห้องเรียน
              </>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <label htmlFor="classNo" className="form-label">ชั้นมัธยมศึกษาปีที่ {c_id}</label>
            </div>
            <div className="mb-3">
              <label htmlFor="roomNo" className="form-label">ห้อง</label>
              <input
                type="text"
                className="form-control"
                id="roomNo"
                value={roomNo}
                placeholder="กรอกห้องเรียน เช่น 1, 2, 3"
                onChange={(e) => setRoomNo(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="programCode" className="form-label">โปรแกรม</label>
              <select
                className="form-control"
                id="programCode"
                value={String(programCode)}
                onChange={(e) => setProgramCode(e.target.value)}
              >
                <option value="">-- เลือกโปรแกรม --</option>
                {programList.map((program) => (
                  <option key={program.p_id} value={String(program.p_id)}>
                    {program.p_code}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="roomGender" className="form-label">เพศ</label>
              <select
                className="form-control"
                id="roomGender"
                value={roomGender}
                onChange={(e) => setRoomGender(e.target.value)}
              >
                <option value="">-- คละ/ไม่ระบุ --</option>
                <option value="m">ชาย</option>
                <option value="f">หญิง</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">อาจารย์ที่ปรึกษา (เลือกได้มากกว่า 1 คน)</label>
              <div
                className="border rounded p-2"
                style={{ maxHeight: "220px", overflowY: "auto" }}
              >
                {teacherList.length === 0 ? (
                  <div className="text-muted small">ไม่มีรายชื่ออาจารย์</div>
                ) : (
                  teacherList.map((teacher) => {
                    const id = String(teacher.t_id);
                    const checked = teacherIds.includes(id);
                    return (
                      <div
                        key={teacher.t_id}
                        className="d-flex align-items-center justify-content-between py-1"
                      >
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`adv-${id}`}
                            checked={checked}
                            onChange={() => toggleTeacher(id)}
                          />
                          <label className="form-check-label" htmlFor={`adv-${id}`}>
                            {teacher.t_name}
                          </label>
                        </div>
                        {checked && (
                          <div className="form-check mb-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="primaryAdvisor"
                              id={`primary-${id}`}
                              checked={String(primaryTeacherId) === id}
                              onChange={() => setPrimaryTeacherId(id)}
                            />
                            <label className="form-check-label small" htmlFor={`primary-${id}`}>
                              ครูหลัก
                            </label>
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
              <small className="text-muted">
                เลือกครูหลัก 1 คน (ชื่อครูหลักจะแสดงในรายงานและโปรไฟล์นักเรียน)
              </small>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            ปิด
          </Button>
          <Button variant="success" type="button" onClick={handleSave}>
            {modalMode === "add" ? "เพิ่มห้องเรียน" : "บันทึกการแก้ไข"}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}